import React from 'react'
import GenericSlideInDialog from 'src/components/common/containers/GenericSlideInDialog'
import ManualSegmentCreationFlow from 'src/components/segments/ManualSegmentCreationFlow'
import { SegmentProvider } from 'src/lib/contexts/SegmentContext'

interface SegmentCreationDialogProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  segmentId?: string
  isEditMode: boolean
  onSuccess?: () => void
}

const ManualSegmentCreationDialog: React.FC<SegmentCreationDialogProps> = ({
  isOpen,
  setIsOpen,
  segmentId,
  isEditMode,
  onSuccess
}) => {
  return (
    <GenericSlideInDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      direction='right'
      width={440}
      hideOverlay
      disableOutsideClick
      className='!rounded-none !bg-zinc-50 !shadow-[10px_0_30px_0_rgba(0,0,0,0.15),_-80px_-20px_48px_0_rgba(250,250,250,0.80)]'
    >
      <div className='flex flex-row flex-1 min-h-0'>
        <div className='w-px h-full shrink-0' style={{ background: 'linear-gradient(180deg, rgba(228, 228, 231, 0.00) 0%, #E4E4E7 50%)' }} />
        <div className='flex flex-col flex-1 min-w-0 min-h-0'>
          <SegmentProvider>
            <ManualSegmentCreationFlow
              segmentId={segmentId}
              isEditMode={isEditMode}
              handleClose={() => setIsOpen(false)}
              onSuccess={onSuccess}
            />
          </SegmentProvider>
        </div>
      </div>
    </GenericSlideInDialog>
  )
}

export default ManualSegmentCreationDialog
